<h2>Commodity Currency & UOM Mapping</h2>

<app-maintenance-table [apiUrl]="url" [columnDefs]="colDefs" [keyFields]="keyColumns"></app-maintenance-table>